import * as v from 'valibot';

const zeroInterestPeriodMessage = 'Please enter a whole number from 6 to 24.';

export const btCalculatorFormSchema = v.object({
  debt: v.pipe(
    v.string('debt must be a string'),
    v.minLength(1, 'Please enter a number.'),
    v.transform(val => Number(val)),
    v.custom<number>(() => true),
  ),
  interestRate: v.pipe(
    v.string('interestRate must be a string'),
    v.minLength(1, 'Please enter a number.'),
    v.transform(val => Number(val)),
    v.custom<number>(() => true),
  ),
  balanceTransferFee: v.number('balanceTransferFee is required'),
  zeroInterestPeriod: v.pipe(
    v.string('zeroInterestPeriod must be a string'),
    v.minLength(1, zeroInterestPeriodMessage),
    v.transform(val => Number(val)),
    v.custom<number>(() => true),
    v.minValue(6, zeroInterestPeriodMessage),
    v.maxValue(24, zeroInterestPeriodMessage),
  ),
});
